module.exports = __webpack_public_path__ + "img/no_bookmarks.543404b.png";